import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const LoadingProgressPage = () => {
  const navigate = useNavigate();
  const { uploadProgress, categorizationStatus } = useSelector((state: RootState) => state.transactions);
  const [startTime] = useState(Date.now());
  const dataSource = sessionStorage.getItem('dataSource');

  useEffect(() => {
    if (categorizationStatus === 'succeeded') {
      const elapsedTime = Date.now() - startTime;
      const remainingTime = Math.max(5000 - elapsedTime, 0);
      
      // Wait for at least 5 seconds before navigating
      setTimeout(() => {
        navigate('/spending');
      }, remainingTime);
    } else if (categorizationStatus === 'failed') {
      // Wait a moment before showing the error
      setTimeout(() => {
        navigate('/connect');
      }, 2000);
    }
  }, [categorizationStatus, navigate, startTime]);

  const getProgressMessage = () => {
    if (categorizationStatus === 'failed') {
      return 'Error processing transactions. Please try again.';
    }

    if (dataSource === 'plaid') {
      if (uploadProgress < 30) return 'Connecting to your bank...';
      if (uploadProgress < 60) return 'Retrieving your transactions...';
      if (uploadProgress < 100) return 'Processing transactions...';
      return 'Almost done...';
    } else {
      if (uploadProgress < 50) return 'Uploading your file...';
      if (uploadProgress < 100) return 'Processing transactions...';
      return 'Almost done...';
    }
  };

  return (
    <div className="min-h-screen bg-[#221A51]/[0.07] flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-purple-dark mb-2">
            {categorizationStatus === 'failed' 
              ? 'Error Processing Transactions'
              : dataSource === 'plaid' 
                ? 'Syncing Your Bank Account' 
                : 'Processing Your Transactions'
            }
          </h1>
          <p className="text-purple-dark/60">
            {categorizationStatus === 'failed' 
              ? 'Please try again'
              : 'This might take a minute...'
            }
          </p>
        </div>

        {/* Progress bar container */}
        <div className="w-full h-4 bg-white rounded-full overflow-hidden border-2 border-black shadow-brutal">
          <motion.div
            className={`h-full ${categorizationStatus === 'failed' ? 'bg-red-500' : 'bg-purple-main'}`}
            initial={{ width: "0%" }}
            animate={{ width: `${uploadProgress}%` }}
            transition={{ duration: 0.5 }}
          />
        </div>

        <p className={`text-center mt-4 ${categorizationStatus === 'failed' ? 'text-red-500' : 'text-purple-dark/80'}`}>
          {getProgressMessage()}
        </p>
      </div>
    </div>
  );
};

export default LoadingProgressPage;
